import { SearchStore } from '@libs/common-types';

export function getPickedStore(storesToShow: SearchStore[], pickedStore?: number, selectedStore?: number) {
    const { pickedItem, myStoreItem } = storesToShow.reduce<{
        pickedItem: number | undefined;
        myStoreItem: number | undefined;
    }>(
        (result, item) => {
            if (item.Store.StoreNumber === pickedStore) {
                return {
                    ...result,
                    pickedItem: item.Store.StoreNumber,
                };
            }
            if (item.Store.StoreNumber === selectedStore) {
                return {
                    ...result,
                    myStoreItem: item.Store.StoreNumber,
                };
            }
            return result;
        },
        {
            pickedItem: undefined,
            myStoreItem: undefined,
        }
    );

    return pickedItem || myStoreItem || undefined;
}
